<template>
  <div class="member-list">
    <div v-if="membersList.length == 0">
      <div style="margin-top: 50%; transform: translateY(-50%)">
        <empty text="没有组员"></empty>
      </div>
    </div>
    <div v-else>
      <q-scroll-area style="height: 600px">
        <div class="member-item" v-for="item in membersList" :key="item.id">
          <div class="info">
            <q-avatar class="tlqn-agmli-avatar_display" size="60px">
              {{ item.nickname.substr(0, 1) }}
            </q-avatar>
            <div class="completed-status">
              <p style="margin-bottom: 5px" ckass="text-subtitle1 text-bold">
                <span class="text-weight-bold">{{ item.nickname }}</span>
                完成样本
                {{ statisticCompleteOfSample(item.samples).sum }} /
                {{ item.samples.length }}
              </p>
              <line-progress
                :progress="statisticCompleteOfSample(item.samples).res"
              ></line-progress>
              <p style="font-size: 14px; margin-top: 5px">查看详情</p>
            </div>

            <q-menu transition-show="scale" transition-hide="scale">
              <div style="min-width: 400px">
                <q-card-section class="row items-center q-pb-none">
                  <div
                    style="margin-left: 10px; font-size: 1rem; font-weight: 600"
                  >
                    {{ item.nickname }}同学负责的样本
                  </div>
                  <q-space />
                  <q-btn icon="fas fa-times" flat round dense v-close-popup />
                </q-card-section>
                <q-btn
                  unelevated
                  rounded
                  text-color="white"
                  color="primary"
                  style="margin: 10px 20px"
                  @click="checkLetOfSamplesDialog()"
                >
                  <q-icon
                    name="fas fa-plus-circle"
                    size="12px"
                    class="q-mr-sm"
                  />
                  <span>批量指定</span>
                </q-btn>

                <!-- 为成员批量选择样本弹窗 -->
                <q-dialog v-model="checkLotOfSamples" full-width full-height>
                  <q-card>
                    <q-card-section class="row items-center q-pb-none">
                      <div
                        style="
                          margin-left: 10px;
                          font-size: 18px;
                          font-weight: 600;
                        "
                      >
                        为{{ item.nickname }}同学指定负责样本
                      </div>
                      <q-space />
                      <q-btn
                        icon="fas fa-times"
                        flat
                        round
                        dense
                        v-close-popup
                        @click="cancelChecked()"
                      />
                      <br />
                    </q-card-section>
                    <p
                      style="margin-left: 25px; font-size: 1rem"
                      class="text-red-6 text-bold"
                    >
                      仅显示未分配且未开始的样本
                    </p>

                    <div class="sample-distribution-dialog">
                      <q-scroll-area
                        v-if="samples && samples.length"
                        id="_virtual_scroll"
                        class="content-box"
                      >
                        <q-virtual-scroll
                          :items="samples"
                          :items-size="samples.length"
                          scroll-target="#_virtual_scroll"
                          :items-fn="
                            (from, size) => {
                              const items = [];
                              for (let i = 0; i < size; i++) {
                                items.push(samples[i]);
                              }
                              return items;
                            }
                          "
                          :virtual-scroll-slice-size="50"
                          :virtual-scroll-slice-ratio-before="20"
                          :virtual-scroll-slice-ratio-after="20"
                        >
                          <template v-slot="{ item, index }">
                            <q-item
                              :key="index"
                              class="rounded-borders q-mb-md q-mx-auto"
                              style="
                              position: relative;
                              box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                              width: 90%;
                              border: 1px solid #ccc;
                            "
                              v-if="
                                sampleForm[`${item.id}`].is_distribution ===
                                  false && item.sample_status == 1
                              "
                            >
                              <q-checkbox
                                ref="checked"
                                v-model="sampleForm[`${item.id}`].available"
                                style="width: 100%"
                              >
                                <p style="margin-top: 5px"></p>
                                <span style="font-weight: 600">{{
                                  item.detail.name
                                }}</span
                                ><br />
                                {{ item.detail.dom }}<br />
                                <span
                                  style="font-size: 0.8rem"
                                  class="text-bold text-red-6"
                                >
                                  未分配
                                </span>

                                <span
                                  class="text-bold"
                                  :style="{
                                    color:
                                      sampleStatusDict[item.sample_status]
                                        .color,
                                    fontSize: '0.8rem',
                                  }"
                                  >{{
                                    sampleStatusDict[item.sample_status]
                                      .description
                                  }}</span
                                >
                              </q-checkbox>
                            </q-item>
                          </template>
                        </q-virtual-scroll>
                      </q-scroll-area>

                      <q-card-section>
                        <map-distributed
                          class="content-box"
                          :samplesprop="checkedSamples"
                        ></map-distributed>
                      </q-card-section>
                    </div>

                    <q-card-actions align="right">
                      <q-btn
                        flat
                        label="取消"
                        color="primary"
                        v-close-popup
                        @click="cancelChecked()"
                      />
                      <q-btn
                        flat
                        label="确定"
                        style="
                          background: #df602f;
                          color: white;
                          margin-right: 10px;
                        "
                        v-close-popup
                        @click="submitChecked(item.id)"
                      />
                    </q-card-actions>
                  </q-card>
                </q-dialog>

                <div
                  v-if="item.samples.length === 0"
                  style="
                    width: 60%;
                    margin: 30px auto;
                    font-size: 20px;
                    color: #124561;
                  "
                >
                  <p>
                    <q-icon name="fas fa-box-open"></q-icon>
                    该同学没有负责的样本
                  </p>
                </div>
                <q-list
                  v-else
                  style="
                    width: 90%;
                    height: 50px;
                    margin: 20px auto;
                    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
                    display: flex;
                    align-items: center;
                    padding: 0 15px;
                  "
                  class="rounded-borders"
                  v-for="principalSample in item.samples"
                  :key="principalSample.id"
                >
                  <div
                    style="
                      line-height: 20px;
                      padding-top: 5px;
                      width: 60%;
                      height: 50px;
                    "
                  >
                    <p
                      class="text-weight-bold"
                      style="
                        margin: 0;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        white-space: nowrap;
                      "
                    >
                      {{ principalSample.detail.name }}
                    </p>
                    <q-tooltip>
                      {{ principalSample.detail.name }}
                    </q-tooltip>

                    <p class="text-caption">
                      样本ID: {{ principalSample.detail.sample_id }}
                    </p>
                  </div>

                  <span
                    class="row justify-center items-center q-ml-sm"
                    :style="{
                      color:
                        sampleStatusDict[principalSample.sample_status].color,
                    }"
                  >
                    <q-icon
                      style="font-size: 15px"
                      :name="
                        `fas ${
                          sampleStatusDict[principalSample.sample_status].icon
                        }`
                      "
                    ></q-icon>
                    <span class="q-mx-sm">{{
                      sampleStatusDict[principalSample.sample_status]
                        .description
                    }}</span>
                  </span>

                  <q-btn
                    v-if="principalSample.sample_status == 1"
                    flat
                    color="positive"
                    icon="fas fa-pen"
                    style="font-size: 10px; margin-left: 0px"
                  >
                    <q-menu>
                      <div style="width: 120px">
                        <q-btn
                          flat
                          size="sm"
                          align="left"
                          label="删除样本"
                          icon="fas fa-trash-alt"
                          style="color: #124561; margin: 5px 0"
                          @click="deleteBindUserAndSample(principalSample.id)"
                        />

                        <!-- <q-btn
                        flat
                        color="#124561"
                        size="sm"
                        align="left"
                        label="指定其他负责人"
                        icon="fas fa-download"
                        style="color: #124561; margin: 5px 0"
                        @click="switchPrincipal()"
                      ></q-btn> -->

                        <q-btn
                          flat
                          color="#124561"
                          size="sm"
                          align="left"
                          label="返回"
                          icon="fas fa-arrow-left"
                          v-close-popup
                          style="color: #124561; margin: 5px 0"
                        ></q-btn>
                      </div>
                    </q-menu>
                  </q-btn>

                  <q-btn
                    v-else
                    flat
                    color="#ccc"
                    icon="fab fa-expeditedssl"
                    display
                    style="font-size: 10px; margin-left: 5px"
                  ></q-btn>
                </q-list>
              </div>
            </q-menu>
          </div>
        </div>
      </q-scroll-area>
    </div>
  </div>
</template>

<script>
import LeaderCommonStatus from "../mixins/status.mixin";
import { SAMPLE_STATUS_DICT } from "../../../../../shared/constants/sample-status";
import { deleteBindUser } from "../../../api/endpoints/sample/deleteBindUser";
import { updateBindUser } from "../../../api/endpoints/sample/updateBindUser";

export default {
  mixins: [LeaderCommonStatus],
  props: ["membersprop", "samplesprop"],
  components: {
    LineProgress: () =>
      import("../../../components/progress-bar/LineProgress.vue"),
    Empty: () => import("../../../components/Empty.vue"),
    MapDistributed: () => import("../Map"),
  },

  data() {
    return {
      membersList: [], // 小组成员列表
      samples: [], // 样本列表
      sampleForm: {}, // 与样本选择复选框绑定的对象
      checkLotOfSamples: false,
      sampleStatusDict: SAMPLE_STATUS_DICT,
      checkedSamples: [],
    };
  },

  computed: {
    membersFromProp() {
      return this.membersprop;
    },

    samplesFromProp() {
      return this.samplesprop;
    },
  },

  watch: {
    membersFromProp: {
      immediate: true,
      handler(members) {
        this.membersList = members;
      },
    },

    samplesFromProp: {
      immediate: true,
      handler(samples) {
        this.samples = samples;
      },
    },

    samples: {
      handler(samples) {
        this.samples = samples;
        this.samples.forEach((item) => {
          let key = item.id;
          // user 字段为空表示还没有被分配
          if (item.user === null) {
            this.$set(this.sampleForm, key, {
              principal_id: null,
              is_distribution: false, // false 表示可以分配
              available: false,
            });
          } else {
            this.$set(this.sampleForm, key, {
              principal_id: item.user.id,
              is_distribution: true, // true 表示不可以分配
              available: true,
            });
          }
        });
      },
    },

    sampleForm: {
      deep: true,
      handler(newSampleForm) {
        console.log("change");
        this.getCheckedSampleInfo(newSampleForm);
      },
    },
  },

  methods: {
    handleVScroll({ ref }) {
      // console.log(ref);
      this.$nextTick(() => {
        this.$forceUpdate();
      });
    },

    /**
     * 每个 checkbox v-model 绑定的是 sampleForm 中的 available
     */

    getCheckedSampleInfo(newSampleForm) {
      for (let key in newSampleForm) {
        if (
          newSampleForm[key].available === true &&
          newSampleForm[key].principal_id === null
        ) {
          let result = this.samples.filter((item) => item.id == key)[0];
          this.checkedSamples.push(result);
        }
      }
    },

    /**
     * 将样本批量分配给小组成员
     */
    submitChecked(memberId) {
      let checkedSampleIdList = [];
      for (let item in this.sampleForm) {
        if (
          this.sampleForm[item].available === true &&
          this.sampleForm[item].principal_id === null
        ) {
          checkedSampleIdList.push(item);
        }
      }
      // 遍历被选中需要分配的样本，逐一提交请求处理
      checkedSampleIdList.forEach(async (sampleId) => {
        try {
          const response = await updateBindUser(sampleId, memberId);
          if (response.status || response.error) {
            this.$q.notify({
              type: "danger",
              message: response.detail || response.message,
            });
          }
          this.updateCurrentGroupLeaderStatus("is_request", sampleId);
        } catch (err) {
          this.$q.notify({ type: "danger", name: "失败" });
        }
      });
    },

    /**
     * 统计样本完成情况
     */
    statisticCompleteOfSample(sampleList) {
      let totalSamples = sampleList.length;
      if (totalSamples == 0) return { sum: 0, res: 0 };
      let sum = 0; // 记录已经完成的样本数量
      sampleList.forEach((sample) => {
        if (sample.sample_status === 0) sum++;
      });
      let res = Math.round((sum / totalSamples) * 100);
      return { sum: sum, res: res };
    },

    /**
     * 删除组员的一个样本
     */
    async deleteBindUserAndSample(sampleId) {
      console.log(sampleId);
      try {
        const response = await deleteBindUser(sampleId);
        if (response.status || response.error) {
          this.$q.notify({
            type: "danger",
            message: response.detail || response.message,
          });
        } else {
          this.updateCurrentGroupLeaderStatus("is_request", sampleId);
          this.$q.notify({
            type: "positive",
            message: "已经取消关联",
          });
        }
      } catch (err) {
        this.$q.notify({ type: "danger", message: "取消关联失败" });
      }
    },

    switchPrincipal() {
      this.$q.notify({ message: "请到切换样本负责人处更新", color: "primary" });
    },

    /**
     * 控制批量分配样本的弹窗
     */
    checkLetOfSamplesDialog() {
      this.checkLotOfSamples = !this.checkLotOfSamples;
    },

    /**
     * 在批量分配样本时
     * 点击 "取消" 后，如果有勾选的样本需要把勾选的样本置为未勾选状态
     */
    cancelChecked() {
      for (let key in this.sampleForm) {
        this.sampleForm[key]["available"] = false;
        this.checkedSamples = [];
      }
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/styles/quasar";

.tlqn-agmli-avatar_display {
  background-color: rgba($primary, 0.2);
  color: $primary;
  font-weight: bold;
}

.member-list {
  width: 80%;
  margin: 0 auto;
  max-height: 630px;
}

.member-list .member-item {
  width: 100%;
  height: 80px;
  margin-bottom: 20px;
  .info {
    cursor: pointer;
    display: flex;
  }

  .completed-status {
    width: 80%;
    height: 80px;
    margin-left: 20px;

    q-linear-progress {
      margin-top: 0px;
    }
  }
}

.checkout-underline::after {
  content: "";
  width: 90%;
  height: 5px;
  position: absolute;
  bottom: 5px;
  left: 10px;
  border-bottom: 1px solid #ccc;
}

@media screen and (max-width: 800px) {
  .content-box {
    height: 36vh;
  }
}

@media screen and (min-width: 800px) {
  .sample-distribution-dialog {
    display: flex;
    flex-direction: row;

    .content-box {
      width: 50vw;
      height: 75vh;
    }
  }
}
</style>
